export const environment = {
  production: true,
  apiUrl: 'api',
  version: '2026.06.23 beta',
};
